module.exports = __webpack_public_path__ + "img/user-lock.bdc67a1a.svg";